
import React from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import LatexRenderer from '../LatexRenderer';

const MathInlineNode = (props: any) => {
  const { node, updateAttributes, selected } = props;
  const { onMathDoubleClick } = props.extension.options;

  const handleDoubleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (onMathDoubleClick) {
      const initialValue = node.attrs.latex;
      const onSave = (newValue: string) => {
        // The popup returns the full string with delimiters, so we extract the content.
        const content = newValue.startsWith('$') && !newValue.startsWith('$$') ? newValue.substring(1, newValue.length - 1) : newValue;
        updateAttributes({ latex: content });
      };
       // Pass the value with delimiters to the popup
      onMathDoubleClick(`$${initialValue}$`, onSave);
    }
  };

  return (
    <NodeViewWrapper as="span" className="inline-block" onDoubleClick={handleDoubleClick}>
      <span 
        className={`math-inline-content px-1 rounded cursor-pointer ${selected ? 'ProseMirror-selectednode' : ''}`}
        contentEditable={false}
      >
        {/* We add delimiters for LatexRenderer, but store only the content */}
        <span className="pointer-events-none">
            <LatexRenderer latex={`$${node.attrs.latex}$`} />
        </span>
      </span>
    </NodeViewWrapper>
  );
};

export default MathInlineNode;
